module.exports = __webpack_public_path__ + "static/media/noun-seat-1027004-142350.49f380dd.svg";